import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { userSelector } from 'slices/userSlice';
import ForgotPassword from 'views/ForgotPassword';

import Login from "views/login";
import InterpretingForm from "views/InterpretingForm" 
import InterpretingForm2 from "views/InterpretingForm2" 
import InterpretingForm3 from "views/InterpretingForm3" 
import Register from "views/register";
import ResetPassword from 'views/ResetPassword';
import AppointmentDetails from 'views/appointment-details';
import TranslationDetails from 'views/translation-details';
import TranslationForm from 'views/TranslationForm';
export const AuthRoutes = () => {
    const { pathname } = useLocation()
    const { isAuthenticated } = useSelector(userSelector);

    // Redirect to admin if already authenticated
    // if (isAuthenticated) {
    //     return <Navigate to="/admin" replace />;
    // }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/interpreting-service-request/generate" element={<InterpretingForm />} />
            <Route path="/interpreting-service-evening-request/generate" element={<InterpretingForm2 />} />
            <Route path="/entrance-exams/generate" element={<InterpretingForm3 />} />
            <Route path="/translation-form/generate" element={<TranslationForm />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Catch-all for unauthenticated users */}
            {/* {pathname !== "/appointment-details" && <Route path={"*"} element={<Navigate to="/login" replace />} />} */}
            {pathname !== "/interview-invite" && <Route path={"*"} element={<Navigate to="/login" replace />} />}
            <Route path="/appointment-details" element={<AppointmentDetails />} />
            <Route path="/translation-details" element={<TranslationDetails />} />
        </Routes>
    )
}
